const initialState = {
   isInProgress: false,
   errors: {},
};

export default initialState;
